// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1fmho","name":"Header_name__I5dN4","birthday":"Header_birthday__2mGY5","skeleton":"Header_skeleton__Zn0u4"};